import auth from '@/auth'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import store from '../store'
import pascalcase from 'pascalcase'

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: '96aeab28-e280-40bd-8cdf-71e3d2f0df0d',
    autoTrackPageVisitTime: true,
    enableAutoRouteTracking: true,
  },
})

appInsights.loadAppInsights()

appInsights.trackPageView()

export function logUserActivity(pageName: string, values = '') {
  appInsights.context.user.id = store.state.userName

  appInsights.trackEvent({
    name: 'VHUBLOG',
    properties: {
      EntityName: pascalcase(store.state.accountId.toLowerCase()),
      PageName: pascalcase(pageName),
      Environment: pascalcase(process.env.VUE_APP_ENVIRONMENT!.toLowerCase()),
      UserName: store.state.userName,
      Values: pascalcase(values),
    },
  })
}

export function logException(exception: string, errorMessage = '', errorDescription = '') {
  appInsights.context.user.id = store.state.userName

  appInsights.trackException({
    error: new Error(exception),
    properties: {
      UserName: store.state.userName,
      EntityName: pascalcase(store.state.accountId.toLowerCase()),
      Environment: pascalcase(process.env.VUE_APP_ENVIRONMENT!.toLowerCase()),
      Message: errorMessage,
      Description: errorDescription,
    },
  })
}
